import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
export const fetchPageSuccess = createAction(`${reduxKey}.PAGE.FETCH.SUCCESS`, (payload)=>payload);
